export function union<T>(a: T[], b: T[]) {
	const setA = new Set(a);
	const setB = new Set(b);

	const unionSet = new Set(setA);

	for (const item of setB) {
		unionSet.add(item);
	}

	return Array.from(unionSet);
}
